import React, { useState } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

import { MoreHorizontal } from "lucide-react";
import { GrupPrestasi } from "@/types";
import Modal from "@/components/Modal";
import Form from "./Form";

export default function Actions({ row }: { row: GrupPrestasi }) {
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState<GrupPrestasi | null>(null);

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowEdit(true);
                setSelectedRow(row);
              }}
            >
              Edit
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                setShowDelete(true);
                setSelectedRow(row);
              }}
            >
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal show={showEdit} onClose={() => setShowEdit(false)}>
        <Form
          closeModal={() => setShowEdit(false)}
          selectedRow={selectedRow}
          method="PATCH"
        />
      </Modal>

      <Modal show={showDelete} onClose={() => setShowDelete(false)}>
        <Form
          closeModal={() => setShowDelete(false)}
          selectedRow={selectedRow}
          method="DELETE"
        />
      </Modal>
    </React.Fragment>
  );
}
